module.exports = __webpack_public_path__ + "img/university_2.52deeb55.png";